import { ReactNode } from "react"
import cx from "classnames"

import CaptionListItem from "./CaptionListItem"

export interface CaptionListProps {
  caption?: ReactNode
  list: ReactNode[] | undefined
  clasName?: string
  captionClass?: string
  itemClass?: string
  size?: "xs" | "sm"
}

const CaptionList = ({
  caption,
  list,
  clasName,
  captionClass,
  itemClass,
  size,
}: CaptionListProps) => {
  if (!list) {
    return null
  }

  return (
    <div className={clasName} data-testid="caption-list">
      {caption ? (
        <div
          className={cx(
            "font-bold leading-[24px] tracking-[0.84px] mb-1",
            captionClass
          )}
        >
          {caption}
        </div>
      ) : null}

      <ul className="pl-5 space-y-1">
        {list.map((item, index) => (
          <CaptionListItem
            key={index}
            item={item}
            className={itemClass}
            size={size}
          />
        ))}
      </ul>
    </div>
  )
}

export default CaptionList
